import { useMemo } from 'react'
import auth from '../../../api/auth/hooks'
import { Contact } from '../../../api/contacts/types'
import { ContactType } from '../../../api/globalTypes'
import { companyGeneralInputs } from '../../../common/forms/company/inputs'
import { companyGeneralValidation } from '../../../common/forms/company/validations'
import { contactGeneralInputs } from '../../../common/forms/contacts/inputs'
import { contactGeneralValidation } from '../../../common/forms/contacts/validations'

export const useContactGeneralFormConfig = (data: Contact | null, contactType: ContactType = ContactType.Person) => {
    const { data: currentAgentId } = auth.CurrentAgent.useQuery({ select: (data) => data.id })

    const defaultData = useMemo(
        () => ({
            agent: { id: currentAgentId },
            contactStatus: { id: '1' },
        }),
        [currentAgentId]
    )

    const generalInputs = useMemo(() => {
        return contactType === ContactType.Person ? contactGeneralInputs() : companyGeneralInputs()
    }, [contactType])

    const generalValidationConfig = useMemo(() => {
        const validationData = data || defaultData

        return contactType === ContactType.Person ? contactGeneralValidation(validationData) : companyGeneralValidation(validationData)
    }, [data, defaultData, contactType])

    return {
        generalInputs,
        generalValidationConfig,
    }
}
